export default {
  SETTIMERVALUE(state, timer) {
    state.currentTimer[timer.key] = timer.value;
  },
  SETSETTINGSACTIVE(state, status) {
    state.settingsActive = status;
  },
};
